import { useParams } from "react-router-dom";
import Breadcrumb from "../../component/Breadcrumb"
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useEffect, useMemo } from "react";
import { fetchFeatures } from "../../store/featureSlice";

const breadcrumbData = {
  newClass: "center-breadcrumb",
  list: [
    {
      page: "Home",
      slug: "/"
    },
    {
      page: "Features",
      slug: ""
    },
  ]
}

export default function FeatureHead() {
  const { featurepageId } = useParams();
  const dispatch = useDispatch();
  const { features, error } = useSelector((state) => state.feature);

  // Function to handle displaying the check/cross based on value
  useEffect(() => {
    dispatch(fetchFeatures());
  }, [dispatch]);

  const selectedFeature = useMemo(() => {
    return features?.find((feature) => feature.slug === featurepageId);
  }, [features, featurepageId]);

  return (
    <>
      <section className="featurepage-head header-gap">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <Breadcrumb breadcrumbData={breadcrumbData} />
              <h1 className="heading"><span className='gradiant-color'>Mobility Infotech</span> <br />{selectedFeature?.title} Features </h1>
            </div>
          </div>
        </div>

        <img loading="lazy" src="/assets/home/featurehead-shape-1.webp" className='featurehead-vector-1' alt="shape" />
        <img loading="lazy" src="/assets/home/featurehead-shape-2.webp" className='featurehead-vector-2' alt="shape" />
      </section>
    </>
  )
}
